import { Component } from '@angular/core';
import { FrameComponent } from '../frame/frame.component';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends FrameComponent {
  isLoggedIn: boolean = false;

  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  protected override async init(): Promise<void> {
    await this.authService.getToken();
    const authorizations = await this.authService.getAuthorizations();
    this.isLoggedIn = await this.authService.isAuthenticated();
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
    this.isLoggedIn = false;
  }
}
